namespace Solovis.Reports.Parameters.Composites {


    export class CompositeLookThroughControl extends Solovis.UI.BaseControl {
        private _lookThrough: CompositeLookThroughData;     
        private _formBuilder: Solovis.UI.InputControls.FormBuilder;

        constructor(options) {
            super(options);

            this._lookThrough = options.lookThrough;
        }

        public doRender() {

            let formBuilderDiv = $("<div>").appendTo(this.container);
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv,
                labelColumnWidth: 200,
                width: 300
            });
            this._formBuilder = formBuilder;            

            formBuilder.addEntry({
                name: "isEnabled",
                label: "Enable Look-Through",

                initialValue: !!this._lookThrough,

                editor: {
                    type: "bool"
                }
            });

            formBuilder.addEntry({
                name: "lookThroughManagedFund",
                label: "Look-Through Managed Fund",

                initialValue: this._lookThrough ? this._lookThrough.lookThroughManagedFund : true,

                editor: {
                    type: "bool"
                },

                isVisible: (formEntry) =>
                {
                    return formEntry.formBuilder.getValueByName("isEnabled");
                }
            });

            formBuilder.addEntry({
                name: "lookThroughDrawdownFund",
                label: "Look-Through Drawdown Fund",

                initialValue: this._lookThrough ? this._lookThrough.lookThroughDrawdownFund : true,

                editor: {
                    type: "bool"
                },

                isVisible: (formEntry) => {
                    return formEntry.formBuilder.getValueByName("isEnabled");
                }
            });

            formBuilder.addEntry({
                name: "maxLookThroughs",
                label: "Max Look-Throughs",

                initialValue: this._lookThrough ? this._lookThrough.maxLookThroughs : null,

                editor: {
                    type: "integer"
                },

                isVisible: (formEntry) => {
                    return formEntry.formBuilder.getValueByName("isEnabled");
                }
            });

            formBuilder.setupDone();
        }


        public setWidth(newWidth) {
            if (this._formBuilder) {
                this._formBuilder.setWidth(newWidth);
            }
        }


        public getLookThrough() {
            if (this._formBuilder.getValueByName("isEnabled")) {
                let lookThrough: CompositeLookThroughData = {};

                lookThrough.lookThroughManagedFund = this._formBuilder.getValueByName("lookThroughManagedFund");
                lookThrough.lookThroughDrawdownFund = this._formBuilder.getValueByName("lookThroughDrawdownFund");

                let maxLookThroughs = this._formBuilder.getValueByName("maxLookThroughs");
                if (Solovis.isNotNull(maxLookThroughs)) {
                    lookThrough.maxLookThroughs = maxLookThroughs;
                }

                return lookThrough;
            }
            else {
                return null;
            }
        }

    }
}